<template>
  <div class="page-container">
    <!-- Top Stage Section -->
    <div
      class="stage-section d-flex justify-content-between align-items-center py-3"
      v-if="currentPath != 'key-account-details'"
    >
      <div class="stage-tracker d-flex align-items-center">
        <span
          v-for="(stage, index) in stages"
          :key="index"
          class="stage-item"
          :class="{ active: currentStage === stage.lead_stage }"
        >
          <div class="stage-circle"></div>
          <p>{{ stage.lead_stage }}</p>
        </span>
      </div>
      <div>
        <select
          v-model="currentStage"
          @change="changeStage"
          class="form-select"
        >
          <option
            v-for="(stage, index) in stages"
            :key="index"
            :value="stage.lead_stage"
          >
            {{ stage.lead_stage }}
          </option>
        </select>
      </div>
    </div>

    <div class="tab-section">
      <ul class="nav nav-tabs">
        <li class="nav-item" v-for="tab in topTabs" :key="tab">
          <button
            class="nav-link"
            :class="{ active: currentTopTab === tab }"
            @click="currentTopTab = tab"
          >
            {{ tab }}
          </button>
        </li>
      </ul>
    </div>

    <div class="middle-section p-3">
      <div v-if="currentTopTab === 'Log Activity'" class="align-items-start">
        <LogActivityForm :leadId="leadId" />
      </div>
      <div v-if="currentTopTab === 'Task'" class="align-items-start">
        <TaskForm :leadId="leadId" :initialInfo="initialInfo" />
      </div>
      <div v-if="currentTopTab === 'Note'" class="align-items-start">
        <NoteForm :leadId="leadId" />
      </div>
      <div v-if="currentTopTab === 'SMS'" class="align-items-start">
        <SMSForm :leadId="leadId" />
      </div>
      <div v-if="currentTopTab === 'Email'" class="align-items-start">
        <EmailForm :leadId="leadId" :concernPersonInfo="concernPersonInfo" />
      </div>
      <div v-if="currentTopTab === 'File'" class="align-items-start">
        <FileForm :leadId="leadId" />
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/utils/http";
import LogActivityForm from "./DetailsForm/LogActivityForm.vue";
import TaskForm from "./DetailsForm/TaskForm.vue";
import NoteForm from "./DetailsForm/NoteForm.vue";
import SMSForm from "./DetailsForm/SMSForm.vue";
import EmailForm from "./DetailsForm/EmailForm.vue";
import FileForm from "./DetailsForm/FileForm.vue";

export default {
  props: {
    leadId: {
      type: String,
      required: true,
    },
    currentLeadStage: {
      type: String,
      required: true,
    },
    concernPersonInfo: {
      type: Array,
      required: true,
    },
    initialInfo: {
      type: Object,
      required: true,
    },
  },
  components: {
    LogActivityForm,
    TaskForm,
    NoteForm,
    SMSForm,
    EmailForm,
    FileForm,
  },
  data() {
    return {
      isLoading: false,
      stages: [],

      currentStage: "",
      topTabs: ["Log Activity", "Task", "Note", "SMS", "Email", "File"],
      currentTopTab: "Log Activity",
      currentPath: "",
    };
  },
  mounted() {
    this.getLeadStages();
    const fullPath = this.$route.fullPath;
    const lastPart = fullPath.split("/").filter(Boolean).pop();
    this.currentPath = lastPart;
  },
  methods: {
    async getLeadStages() {
      const endpoint = `/lead-stages`;
      const method = "get";
      try {
        const response = await http[method](endpoint);
        this.currentStage = this.currentLeadStage;
        this.stages = response.data.contents.map((stage) => {
          return {
            lead_stage: stage.lead_stage,
          };
        });
      } catch (error) {}
    },

    async changeStage() {
      const endpoint = "/leads-stage-update";
      const method = "post";
      let body = {
        lead_id: this.leadId,
        lead_stage: this.currentStage,
      };
      try {
        const response = await http[method](endpoint, body);
        this.$toast.success(response.data.message);
      } catch (error) {
      } finally {
      }
    },
    formSubmitted() {
      this.$emitter.emit("load-tab-details");
    },
  },
};
</script>

<style scoped>
.page-container {
  max-width: 1200px;
  margin: auto;
}

.stage-section {
  border-bottom: 1px solid #ddd;
}

.stage-tracker {
  gap: 20px;
}

.stage-item {
  text-align: center;
  cursor: pointer;
}

.stage-circle {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: #ddd;
  margin: auto;
}

.stage-item.active .stage-circle {
  background-color: #7c063b;
}

.tab-section {
  margin-bottom: 20px;
}

.tab-section .nav-tabs {
  border-bottom: none;
  background: #e3efff;
}

.nav-item {
  padding: 7px;
}

.tab-section .nav-tabs .nav-link {
  border: 1px solid transparent;
  border-radius: 5px;
}

.tab-section .nav-tabs .nav-link.active {
  /* border-color: #007bff;
    border-bottom: 2px solid #007bff; */
  background-color: #4285f4;
  color: #ffffff;
}

.middle-section {
  background: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 8px;
  min-height: 200px;
}

.bottom-tab-section .nav-pills .nav-link.active {
  background-color: #007bff;
}

.radio-group .form-check {
  margin-bottom: 10px;
}

.middle-section .btn.active {
  background-color: #007bff;
  color: #fff;
}

.middle-section .template-buttons {
  display: flex;
  gap: 5px;
}

.radio-group .form-check {
  margin-bottom: 10px;
}
.task-form label {
  font-weight: bold;
}

.task-form .form-label span.text-danger {
  color: #d9534f;
}

.task-form .btn-outline-primary {
  display: flex;
  justify-content: center;
  align-items: center;
}

.task-form .btn-outline-primary i {
  margin-left: 5px;
}

.file-upload-form {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  font-family: Arial, sans-serif;
}

.tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
}

.tabs button {
  padding: 10px 15px;
  border: none;
  background: #f0f0f0;
  cursor: pointer;
  font-size: 14px;
  border-radius: 5px;
}

.tabs button.active {
  background: #007bff;
  color: white;
}

.form-section {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.description-box {
  width: 100%;
  padding: 10px;
  font-size: 14px;
  border: 1px solid #ddd;
  border-radius: 5px;
}

.border-end {
  border-right: 1px solid #ddd; /* Adjust color or width */
}
</style>
